import { useMemo, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { modifierCategories, modifiers } from '../data/modifiers';

const { FiSearch } = FiIcons;

function ModifierTable() {
  const [category, setCategory] = useState('all');
  const [query, setQuery] = useState('');

  const filteredModifiers = useMemo(() => {
    const normalizedQuery = query.trim().toLowerCase();

    return modifiers.filter((modifier) => {
      const matchesCategory = category === 'all' || modifier.category === category;
      const searchable = [
        modifier.code,
        modifier.name,
        modifier.categoryLabel,
        modifier.rule,
        modifier.tip
      ].join(' ').toLowerCase();

      return matchesCategory && searchable.includes(normalizedQuery);
    });
  }, [category, query]);

  return (
    <section className="modifier-reference">
      <div className="reference-heading">
        <div>
          <span className="content-label">Reference table</span>
          <h2>Searchable modifier guide</h2>
        </div>
        <span className="result-count">{filteredModifiers.length} modifiers</span>
      </div>

      <div className="modifier-toolbar">
        <div className="modifier-search">
          <SafeIcon icon={FiSearch} />
          <input
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            placeholder="Search code, name, rule, or keyword..."
            aria-label="Search modifiers"
          />
        </div>
        <div className="modifier-tabs" role="tablist" aria-label="Modifier categories">
          {modifierCategories.map((item) => (
            <button
              key={item.key}
              className={category === item.key ? 'is-active' : ''}
              onClick={() => setCategory(item.key)}
              role="tab"
              aria-selected={category === item.key}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>

      {filteredModifiers.length ? (
        <div className="modifier-table-wrap">
          <table className="modifier-table">
            <thead>
              <tr>
                <th>Code</th>
                <th>Name</th>
                <th>Category</th>
                <th>Key rule</th>
                <th>Exam tip</th>
              </tr>
            </thead>
            <tbody>
              {filteredModifiers.map((modifier) => (
                <tr key={modifier.code}>
                  <td><strong className="modifier-code">{modifier.code}</strong></td>
                  <td><strong>{modifier.name}</strong></td>
                  <td><span className={`category-pill category-${modifier.category}`}>{modifier.categoryLabel}</span></td>
                  <td>{modifier.rule}</td>
                  <td>{modifier.tip}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="modifier-empty">
          <h3>No modifiers found</h3>
          <p>Try a different search phrase or choose All Modifiers.</p>
        </div>
      )}
    </section>
  );
}

export default ModifierTable;